import React from 'react';
import Col from 'react-bootstrap/Col';
import './shopping-cart-header-component.styles.scss'
function ShoppingCardHeaderComponent() {
  return (
    <Col xs={12} className="text-content-container review-shopping">
      <div className="text-content background transparent">
        <div className="inner-wrapper  trinity-container">
          <p className="m-0 review-shopping-header">Review Shopping Cart</p>
        </div>
      </div>
    </Col>
  );
}

export default ShoppingCardHeaderComponent;